import styled from 'styled-components';

export const VehicleCapabilityContainer = styled.div`
  background: rgba(0, 0, 0, 0.12);
  border-radius: 2px;
  display: inline-block;
  font-size: 20px;
  margin-right: 5px;
  padding: 1px 2px;

  & svg * {
    fill: #222222;
  }
`;

export const IconWrapper = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;
